<template>
  <div>
    <loading v-if="yukleniyor"></loading>
    <!--tolpantilar burada gelecek-->
    <div v-if="noDataYet === false" class="text-center d-flex flex-wrap justify-content-around">
      <b-card
          class="mb-2 gostergeler"
          tag="article"
          title="Açık Sunucu Sayısı"
      >
        <b-card-text style="font-size: 30px; font-weight: bold;">
          {{ acikSunucuSayisiUst }}
        </b-card-text>
      </b-card>
      <b-card
          class="mb-2 gostergeler"
          tag="article"
          title="Ayrılan Kapasite"
      >
        <b-card-text style="font-size: 30px; font-weight: bold;">
          {{ ayrilanKapasiteUst }}
        </b-card-text>
      </b-card>
      <b-card
          class="mb-2 gostergeler"
          tag="article"
          title="Aktif Kişi Sayısı"
      >
        <b-card-text style="font-size: 30px; font-weight: bold;">
          {{ aktifKisiSayisiUst }}
        </b-card-text>
      </b-card>
      <b-card
          class="mb-2 gostergeler"
          tag="article"
          title="Ayrılan Toplantı Sayisi"
      >
        <b-card-text style="font-size: 30px; font-weight: bold;">
          {{ ayrilanToplantiSayisiUst }}
        </b-card-text>
      </b-card>
      <b-card
          class="mb-2 gostergeler"
          tag="article"
          title="Aktif Toplantı Sayisi"
      >
        <b-card-text style="font-size: 30px; font-weight: bold;">
          {{ aktifToplantiSayisiUst }}
        </b-card-text>
      </b-card>
    </div>

    <!-- server icerisindeki dersleri gosteren alan -->
    <!--guncelleme alaninin oldugu alan-->
    <div class="d-flex justify-content-start m-2" v-if="serverDataIsLoading === false && noDataYet === false">
      <p class="d-flex justify-content-center align-content-end mt-1 mr-3"
         style="font-size: 20px;  font-weight: bold;"> Yenileme Süresi (Saniye) : </p>
      <b-form-input
          v-model="refreshTime"
          @change="refreshTimeChange"
          type="number"
          style="width:100px !important; text-align: center"
          class="mb-2 mr-sm-2 mb-sm-0"
      ></b-form-input>
    </div>
    <!--server apex chartini gosterildigi yer -->
    <div v-if="yukleniyor === true && noDataYet === true">
      <nodatayet></nodatayet>
    </div>
    <div class="example " v-if="yukleniyor === false && noDataYet === false" style="overflow: scroll">
      <apexchart
          height="450px"
          width='2500px'
          :options="chartOptions"
          :series="chartOptions.series"
          @dataPointSelection="dataPointSelection"
          ref="lokumata"
      ></apexchart>
    </div>
    <div ref="chart"></div>
    <!--loading circle sinin oldugu alan -->

    <b-modal id="sunucuDetayModal" :title="selectedServer ? selectedServer.isim : '' +' Toplantılar'" size="xl"
             @close="onHide" ok-title="Kapat" :ok-only="true">

      <p>{{ meetings.length }} tane toplantı var.</p>


      <b-button class="my-2 ml-2" variant="info" @click="createMeetingAndJoin()">
        Toplanti Olustur ve Katıl
      </b-button>

      <b-table :fields="fields" :items="meetings" :busy="modalLoading" hover striped>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Yükleniyor...</strong>
          </div>
        </template>
        <template v-slot:cell(Isim)="data">
          <a :href="data.item.Link" style="font-size: 20px;" target="_blank">
            <span>
            {{ data.item.Isim }}
            </span>
          </a>
        </template>
        <template v-slot:cell(kacKisiVar)="data">
          <span
              v-if="data.item.MeetingsInfo && data.item.MeetingsInfo.Attendees&&
              data.item.MeetingsInfo.Attendees.Attendee &&
              data.item.MeetingsInfo.Attendees.Attendee">
            {{ data.item.MeetingsInfo.Attendees.Attendee.length }}
          </span>
          <span v-else>0</span>
        </template>
        <template v-slot:cell(sesliKatilan)="data">
          <span v-if="data.item.MeetingsInfo">
                      {{ data.item.MeetingsInfo.VoiceParticipantCount }}
          </span>
        </template>
        <template v-slot:cell(kameraliKatilan)="data">
          <span v-if="data.item.VideoCount">
                      {{ data.item.MeetingsInfo.VideoCount }}
          </span>
        </template>
        <template v-slot:cell(DetayBaslangicTarihi)="data">
          {{ getDateFromStr(data.item.DetayBaslangicTarihi) }}
        </template>
      </b-table>
    </b-modal>

  </div>
</template>

<script>
import ApexCharts from 'vue-apexcharts'
import loading from "@/components/LoadingSpiner";
import nodatayet from "@/components/NoDataYet";
import customMoment from 'moment'
import {Turkish} from "flatpickr/dist/l10n/tr.js";
import request from "@/request"

customMoment.locale('tr')

export default {
  name: 'apex_server',
  components: {
    apexchart: ApexCharts,
    loading,
    nodatayet
  },
  props: ['y_mesaj'],
  data() {
    return {
      refreshTime: 15,
      dateTimeConfig: {
        altInput: true,
        allowInput: true,
        dateFormat: 'Z',
        altFormat: 'd-M-Y',
        locale: Turkish
      },
      moment: customMoment,
      tekrarlama: null,
      baseURL: "https://monitor.hayrat.dev/",


      //serverlarin icindeki verileri tutun degiskenler
      modalLoading: false,
      noDataYet: false,
      meetings: [],
      fields: [

        {
          key: 'HangiProje',
          label: 'Proje İsmi',
          sortable: true
        },
        {
          key: 'Isim',
          label: 'Toplantı İsmi',
          sortable: true
        },
        {
          key: 'MetaData',
          label: 'Detay',
          sortable: true
        },
        {
          key: 'DetayBaslangicTarihi',
          label: 'Başlangıç Tarihi',
          sortable: true
        },
        {
          key: 'Sure',
          label: 'Toplantı Süresi'
        },
        {
          key: 'TahminiKatilimci',
          label: 'Tahmini Katilimci'
        },
        {
          key: 'kacKisiVar',
          label: 'Online Kişi Sayısı'
        },
        {
          key: 'sesliKatilan',
          label: 'Sesli Katılan'
        },
        {
          key: 'kameraliKatilan',
          label: 'Kameralı Katılan'
        },
        {
          key: 'katilimOrani',
          label: "Katilim Orani",
          formatter: (value, key, row) => {
            if (!row || !row.MeetingsInfo || !row.MeetingsInfo.Attendees || !row.MeetingsInfo.Attendees.Attendee) {
              return "%0"
            }
            return "%" + parseInt(((row.MeetingsInfo.Attendees.Attendee.length / row.TahminiKatilimci) * 100).toString(), 10)
          }
        }
      ],

      acikSunucuSayisiUst: 0,
      ayrilanKapasiteUst: 0,
      aktifKisiSayisiUst: 0,
      ayrilanToplantiSayisiUst: 0,
      aktifToplantiSayisiUst: 0,

      //apex chart icin olmasi gereken attributeler
      noData: {
        text: "Loading..."
      },
      chartOptions: {
        series: [],
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: 90,
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transperan']
        },
        colors: ['#B22222', '#228B22', '#8A2BE2', '#0000CD'],
        xaxis: {
          max: '90%',
          labels: {
            router: -45
          },
          categories: [],
          tickPlacement: 'on'
        },
        yaxis: {
          title: {
            text: this.y_mesaj,
          },
        },
        fill: {
          opacity: 1,
          axisTicks: {
            width: 50,
          }
        },
        tooltip: {},
      },
      sunucuBazli: [],
      yukleniyor: true,
      serverDataIsLoading: true,
      selectedServer: [],
    }
  },
  async mounted() {
    this.yukleniyor = true
    await this.totalGosterge()
    this.tekrarlama = setInterval(async () => {
      await this.totalGosterge()
    }, this.refreshTime * 1000)
    this.yukleniyor = false
  },
  computed: {
    createMeetingUrl() {
      return `${this.selectedServer != null ? this.selectedServer.sunucu_url : ''}bigbluebutton/api/create?name=deneme&meetingID=bay-17404248-72b3-46e5-8917-9044ee8ae21a&moderatorPW=mp&attendeePW=ap&welcome=Bismillah&logoutURL=https://yazokulu.hayrategitim.com&lockSettingsDisableCam=True&webcamsOnlyForModerator=False&lockSettingsDisableMic=False&lockSettingsDisablePrivateChat=False&lockSettingsDisablePublicChat=False&isBreakout=false&allowModsToUnmuteUsers=true&lockSettingsLockOnJoinConfigurable=true&duration=30&meta_katilimcisayisi=1&meta_il=Isparta&meta_ilce=Merkez&meta_hoca=Mehmet+Enes+PAZAR&checksum=9581bfbf9c27cb4b37d97938ecb1a2fa2c899006`;
    }
  },
  beforeDestroy() {
    if (this.tekrarlama) {
      clearInterval(this.tekrarlama)
      this.tekrarlama = null
    }
  },

  methods: {
    async refreshTimeChange() {
      if (this.tekrarlama) {
        clearInterval(this.tekrarlama)
        this.tekrarlama = null
      }
      await this.totalGosterge()
      this.tekrarlama = setInterval(async () => {
        await this.totalGosterge()
      }, this.refreshTime * 1000)
    },
    dataPointSelection: function (event, chartContext, config) {
      this.selectServer(config.dataPointIndex)
    },
    async selectServer(index) {
      this.meetings = []
      this.modalLoading = true
      try {
        this.selectedServer = this.sunucuBazli[index]
        this.$bvModal.show('sunucuDetayModal')
        const result = await request({method: 'GET', url: 'rapor/sunucu/' + this.selectedServer.isim})
        if (result.data) {
          this.meetings = result.data
        }
      } catch (e) {
        console.log(e)
      }
      this.modalLoading = false
    },
    getDateFromStr(date) {
      return this.moment(date).format('LLL')
    },

    async createMeetingAndJoin() {
      window.open(`${this.selectedServer.sunucu_url}demo/demo1.jsp`, "_blank")
    },
    onHide() {
      this.selectedServer = null
    },
    //Server datalar apisine istek atan yer
    async totalGosterge() {
      try {
        const result = await request({method: 'GET', url: "rapor"})
        if (result.data) {
          this.sunucuBazli = result.data.sunucu_bazli
          this.noDataYet = false
          this.acikSunucuSayisiUst = result.data.toplanti_devam_eden_sunucu_sayisi
          this.ayrilanKapasiteUst = result.data.toplam_ayrilan_kapasite
          this.aktifKisiSayisiUst = result.data.toplam_aktif_kisi
          this.ayrilanToplantiSayisiUst = result.data.toplam_ayrilan_toplanti
          this.aktifToplantiSayisiUst = result.data.toplam_aktif_toplanti
          this.serverData(result.data)
        } else {
          this.noDataYet = true
          this.serverData(null)
        }
      } catch (e) {
        console.error(e)
      }
    },

// server dataları burada degiskenlere atiliyor
    serverData(data) {
      let aktifKisi = []
      let ayrilanKapasite = []
      let ayrilanToplantiSayisi = []
      let aktifToplantiSayisi = []
      let isimler = []
      try {
        if (data) {
          let totalVeri = data.sunucu_bazli
          totalVeri.forEach((deger) => {
            aktifKisi.push(deger.aktif_kisi)
            ayrilanKapasite.push(deger.ayrilan_kapasite)
            ayrilanToplantiSayisi.push(deger.ayrilan_toplanti)
            aktifToplantiSayisi.push(deger.aktif_toplanti)
            isimler.push(deger.isim)
          })
        }

        this.chartOptions.series = []
        this.chartOptions.xaxis.categories = []
        this.fill_server_data(ayrilanKapasite, aktifKisi, ayrilanToplantiSayisi, aktifToplantiSayisi, isimler)
      } catch (e) {
        this.showErrorMessageToast(e)
      }
      this.serverDataIsLoading = false
    }
    ,
// degiskenlerden veriler apex chart degiskenlerine atiliyor
    fill_server_data(ayrilanKapasite, aktifKisi, ayrilanToplantiSayisi, aktifToplantiSayisi, isimler) {
      this.chartOptions.series = [
        {
          name: 'Ayrılan Kapasite',
          data: ayrilanKapasite,
        },
        {
          name: 'Aktif Kişi Sayısı',
          data: aktifKisi,
        },
        {
          name: 'Ayrılan Toplanti Sayisi',
          data: ayrilanToplantiSayisi,
        },
        {
          name: 'Aktif Toplanti Sayisi',
          data: aktifToplantiSayisi,
        },
      ]
      this.chartOptions = {
        ...this.chartOptions, ...{
          xaxis: {
            categories: isimler,
          },
        }
      }
    },
  }
}
</script>

<style>
@media only screen and (max-width: 600px) {
  .gostergeler {
    width: 250px;
  }
}

</style>